/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_No_Plan_HelpInputs */

const fr_admin_subscription_rights_no_plan_help = /** @type {(inputs: Admin_Subscription_Rights_No_Plan_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans palier, le membre retrouve l'accès par défaut à tous les cours et n'est soumis à aucun quota.`)
};

/**

* @param {Admin_Subscription_Rights_No_Plan_HelpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_no_plan_help = /** @type {((inputs?: Admin_Subscription_Rights_No_Plan_HelpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_No_Plan_HelpInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_no_plan_help(inputs)
});